"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es6.object.define-property");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneInput = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var react_intl_tel_input_1 = tslib_1.__importDefault(require("react-intl-tel-input"));

require("react-intl-tel-input/dist/main.css");

var helpers_1 = require("../../helpers");

var PhoneInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(PhoneInput, _React$PureComponent);

  var _super = _createSuper(PhoneInput);

  function PhoneInput() {
    _classCallCheck(this, PhoneInput);

    return _super.apply(this, arguments);
  }

  _createClass(PhoneInput, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          defaultValue = _this$props.defaultValue,
          disabled = _this$props.disabled,
          block = _this$props.block;

      var onChangePhone = function onChangePhone(fullNumber, isValid) {
        var _this$props2 = _this.props,
            onChange = _this$props2.onChange,
            validateTrigger = _this$props2.validateTrigger;

        if (isValid) {
          onChange(helpers_1.Format.getPhone(fullNumber));
          return;
        }

        validateTrigger('Wrong phone format');
      };

      var locale = getCurrentCountry();
      var containerClassDisabled = disabled ? 'clp-phone-input__container_disabled' : '';
      var containerClassBlock = block ? 'clp-phone-input__container_block' : '';
      var inputClassBlock = block ? 'clp-phone-input__input_block' : '';
      return React.createElement(react_intl_tel_input_1["default"], {
        disabled: disabled,
        preferredCountries: preferredCountries,
        defaultCountry: locale,
        defaultValue: defaultValue,
        inputClassName: "".concat(inputClassBase, " ").concat(inputClassBlock),
        containerClassName: "".concat(containerClassBase, " ").concat(containerClassBlock, " ").concat(containerClassDisabled),
        onPhoneNumberChange: function onPhoneNumberChange() {
          var isValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          var newNumber = arguments.length > 1 ? arguments[1] : undefined;
          var countryData = arguments.length > 2 ? arguments[2] : undefined;
          var fullNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
          onChangePhone(fullNumber, isValid);
        },
        onSelectFlag: function onSelectFlag(currentNumber, countryData) {
          var fullNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
          var isValid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
          onChangePhone(fullNumber, isValid);
        },
        separateDialCode: true,
        formatOnInit: true,
        format: false
      });
    }
  }]);

  return PhoneInput;
}(React.PureComponent);

exports.PhoneInput = PhoneInput;
var preferredCountries = ['fr', 'us'];
var containerClassBase = 'intl-tel--extra intl-tel-input clp-phone-input__container clp-phone-input';
var inputClassBase = 'intl-tel--input form-control clp-phone-input__input';

function getCurrentCountry() {
  var _a;

  var lng = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.language;
  return (lng === null || lng === void 0 ? void 0 : lng.length) >= 2 ? lng.slice(0, 2) : undefined;
}